<template>
  <div class="out_box">
    <div class="a_title">个人资料</div>
    <div class="a_line">
      <span>账户名：</span>
      <p>{{ userInfo.nickname }}</p>
      <el-button type="text" @click="cancelAccount">注销账户</el-button>
    </div>
    <div class="a_line">
      <span>手机号：</span>
      <p>{{ userInfo.mobile }}</p>
      <el-button type="text" @click="handleEdit('mobile')">修改手机号</el-button>
    </div>
    <div class="a_line">
      <span>账户积分：</span>
      <p>{{ userInfo.beans }}</p>
      <el-button type="text" @click="$router.push('/recharge')">前往充值</el-button>
    </div>
    <div class="a_line">
      <span>账户角色：</span>
      <p>{{ userInfo.roles[0].name }}</p>
      <el-button type="text" @click="handleEdit('pwd')">修改密码</el-button>
    </div>
    <!-- <div class="a_title">余额</div> -->
    <el-dialog class="main_dialog" :title="editType == 'pwd' ? '修改密码' : '修改手机号'" :visible.sync="dialogEditVisible" width="450px">
      <el-form :model="pwdForm" :rules="pwdRules" label-position="top" ref="pwdForm" hide-required-asterisk v-if="editType == 'pwd'">
        <el-form-item label="当前密码" prop="current_password">
          <el-input v-model="pwdForm.current_password" placeholder="请填写当前密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="new_password">
          <el-input v-model="pwdForm.new_password" placeholder="请填写新密码"></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirm_password">
          <el-input v-model="pwdForm.confirm_password" placeholder="请再次确认新密码"></el-input>
        </el-form-item>
      </el-form>
      <el-form :model="mobileForm" :rules="mobileRules" label-position="top" ref="mobileForm" hide-required-asterisk v-else>
        <el-form-item label="新手机号码" prop="new_mobile">
          <el-input v-model="mobileForm.new_mobile" placeholder="请填写新手机号码" class="codeinput">
            <el-button slot="append" @click="getVerificateCode" v-if="!showCountDown">获取验证码</el-button>
            <el-statistic
              v-else
              slot="append"
              @finish="showCountDown = false"
              :value="countdown"
              format="s"
              time-indices
            >
              <template slot="suffix">
                s
              </template>
            </el-statistic>
          </el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <el-input v-model="mobileForm.code" placeholder="请填写验证码"></el-input>
        </el-form-item>
      </el-form>
      <el-button class="dialog_confirm" size="small" @click="handleSubmitForm">确 定</el-button>
      <el-button class="dialog_cancel" size="small" @click="dialogEditVisible = false">取 消</el-button>
    </el-dialog>
  </div>
</template>
<script>
import { userUpdateMobile, userChangePassword, userDeleteAccount, userSendCode } from '@/api/user'
import router from '../../router';
export default {
  name: "accountManage",
  data () {
    return {
      dialogEditVisible: false,
      editType: '',
      pwdForm: {
        current_password: '',
        new_password: '',
        confirm_password: ''
      },
      pwdRules: {
        current_password: [{ required: true, trigger: 'blur', message: '请填写当前密码' }],
        new_password: [{ required: true, trigger: 'blur', message: '请填写新密码' }],
        confirm_password: [{ required: true, trigger: 'blur', validator (rule, value, callback) { 
          if(value == self.ruleForm.password) {
            callback()
          }else {
            callback(new Error('请填写正确的密码'));
          }
        }}]
      },
      mobileForm: {
        new_mobile: '',
        code: ''
      },
      mobileRules: {
        new_mobile: [{ required: true, trigger: 'blur', message: '请填写用户名' }],
        code: [{ required: true, trigger: 'blur', message: '请填写验证码' }],
      },
      showCountDown: false,
      countdown: Date.now() + 1000 * 60,
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo
    },
  },
  methods:{
    getVerificateCode() {
      userSendCode({mobile: this.mobileForm.new_mobile}).then(res => {
        this.showCountDown = true
        this.countdown = Date.now() + 1000 * 60
        this.$message.success('发送成功')
      })
    },
    handleEdit(type) {
      this.editType = type
      this.dialogEditVisible = true
    },
    handleSubmitForm() {
      if(this.editType == 'pwd') {
        this.$refs.pwdForm.validate((valid) => {
          if (valid) {
            userChangePassword(this.pwdForm).then(async res => {
              this.$message.success('密码修改成功，请重新登录')
              await this.$store.dispatch('USER_LOGOUT')
              this.$router.push(`/login`)
            })
          }
        })
      }else {
        this.$refs.mobileForm.validate((valid) => {
          if (valid) {
            userUpdateMobile(this.mobileForm).then(async res => {
              this.$message.success('手机号码修改成功，请重新登录')
              await this.$store.dispatch('USER_LOGOUT')
              this.$router.push(`/login`)
            })
          }
        })
      }
      
    },
    cancelAccount() {
      this.$confirm('是否注销该账号?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        userDeleteAccount().then(async res => {
          await this.$store.dispatch('USER_LOGOUT')
          // this.$router.push(`/login?redirect=${this.$route.fullPath}`)
          this.$router.push(`/login`)
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.out_box {
  border-radius: 8px;
  background: #FFFFFF;
  padding: 24px 16px;
  .a_title {
    padding: 24px 16px;
    border-bottom: 1px solid #c7c7c7;
    &:first-child {
      padding-top: 0;
    }
  }
  .a_line {
    padding-left: 16px;
    margin-top: 24px;
    span {
      display: inline-block;
      width: 92px;
      color: #6a6a6a;
    }
    p {
      display: inline-block;
      width: 172px;
    }
  }
  .a_btnbox {
    margin-top: 24px;
    padding-left: 16px;
    .el-button {
      // height: 32px;
      // line-height: 32px;
      // padding: 0 12px;
      // background: linear-gradient(90deg, #4691E7 0%, #3186E5 100%);
      // border: none;
      // color: #fff;
      &+.el-button {
        margin-left: 18px;
      }
    }
  }
  /deep/ .el-form-item__content{
    .el-input  {
      .el-input-group__append {
        background: linear-gradient(90deg, #132632 0%, #3E4B4F 100%);
        border-color: #424D6E;
        width: 112px;
        color: #FFFFFF;
        .el-statistic .con {
          color: #FFFFFF;
          .suffix {
            font-size: 20px;
          }
        }
      }
    }
  }
}
</style>